import { FRAME_SHAPES, frameShapeLabel, type FrameShape } from "../../catalog/taxonomy";

/**
 * The one frame shape a pair of glasses has.
 *
 * Native radio inputs, sharing one name. That is not a stylistic choice: a
 * radio group is single-select in the browser itself, so a second shape cannot
 * be selected even if some future code forgets to clear the first. Checkboxes
 * styled to look single-select would put that guarantee in our own hands, and
 * a glasses product with two shapes is unfilterable on the phone.
 *
 * There is no free-text box and no "Other". The phone can only filter by the
 * thirteen shapes it ships icons for, so a fourteenth value would create a
 * product no shopper browsing by shape could ever reach.
 */
export function FrameShapeSelect({
  value,
  onChange,
  disabled = false,
}: {
  value: FrameShape | null;
  onChange: (shape: FrameShape) => void;
  disabled?: boolean;
}) {
  return (
    <fieldset className="field" disabled={disabled}>
      <legend className="field__label">Frame shape</legend>
      <p className="field__hint">Choose the one shape this frame is.</p>
      <div className="shapeGrid">
        {FRAME_SHAPES.map((shape) => (
          <label
            key={shape}
            className={value === shape ? "shapeOption is-selected" : "shapeOption"}
          >
            <input
              type="radio"
              name="frame-shape"
              value={shape}
              checked={value === shape}
              onChange={() => onChange(shape)}
            />
            <span className="shapeOption__label">{frameShapeLabel(shape)}</span>
          </label>
        ))}
      </div>
    </fieldset>
  );
}
